// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"873ac7ab","455":"308db206","977":"837bf289"}[chunkId] + ".chunk.js";
};